import * as React from 'react'
import cx from 'classnames'
import styles from './IconVisual.sass'

interface IconVisualProps {
  children?: React.ReactNode
  muted?: boolean
  tight?: boolean
}

/**
 " Icon Visual
 */
export default function IconVisual({
  children,
  muted,
  tight,
}: IconVisualProps) {
  return (
    <div
      className={cx(styles.root, muted && styles.muted, tight && styles.tight)}
    >
      {children}
    </div>
  )
}
